import React from "react";
import {useTranslation} from "react-i18next";
import { motion } from "framer-motion";
import CommercialVehicleCard from "../../utility/CommercialVehicleCard";
import { fadeInUp, staggerContainer, staggerItem } from "../../utility/framerMotionAnimations";

const InventoryFinancingBusinessSection = () =>{
    const {t}=useTranslation('inventoryFinancingPage');
    return(
        <>
        <section className="section-container">
            <div className="commercial-vehicle-business-section">
                <motion.div 
                    className="commercial-vehicle-business-section-top"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
                    variants={fadeInUp}
                >
                    <motion.div 
                        className="inventory-financing-business-section-top-content"
                        variants={fadeInUp}
                    >
                    {t('inventory-financing-business-section-heading')}
                    <p>{t('inventory-financing-business-section-description')}</p>
                    </motion.div>
                </motion.div>
            </div>
        </section>
        <section className="card-section-container">
        <motion.div 
            className="commercial-vehicle-business-section-bottom"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.2, margin: "0px 0px -100px 0px" }}
        >
                    <motion.div 
                        className="commercial-vehicle-business-section-bottom-sliding-div"
                        variants={staggerItem}
                    >
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card1.title')} 
                        content={t('inventory-financing-business-card1.description')} 
                        backgroundColor="linear-gradient(138.62deg, #E5DBEF 0.09%, #FFFFFF 69.08%)"
                        image="/images/inventory-card-img1.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card2.title')}  
                        content={t('inventory-financing-business-card2.description')}  
                        backgroundColor="linear-gradient(138.62deg, rgba(252, 196, 157, 0.62) 0.09%, #FFFFFF 69.08%)"
                        image="/images/inventory-card-img2.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card3.title')}  
                        content={t('inventory-financing-business-card3.description')} 
                        backgroundColor="linear-gradient(138.76deg, #D0D9F0 1.91%, #FFFFFF 79.24%)"
                        image="/images/inventory-card-img3.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card4.title')}  
                        content={t('inventory-financing-business-card4.description')}  
                        backgroundColor="linear-gradient(140.06deg, #F4E7D4 1.2%, #FFFFFF 78.92%)"
                        image="/images/inventory-card-img4.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card5.title')} 
                        content={t('inventory-financing-business-card5.description')} 
                        backgroundColor="linear-gradient(139.04deg, #CDE3ED 2.39%, #FFFFFF 67%)"
                        image="/images/inventory-card-img5.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card6.title')} 
                        content={t('inventory-financing-business-card6.description')}  
                        backgroundColor="linear-gradient(138.62deg, #F2CFD7 0.09%, #FFFFFF 76.08%)"
                        image="/images/quick-approval-img.png"
                    />
                    </motion.div>
                    {/*Add `aria-hidden` to hide the duplicated cards from screen readers.*/}
                    <motion.div 
                        className="ariaihidden commercial-vehicle-business-section-bottom-sliding-div"
                        variants={staggerItem}
                    >
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card1.title')} 
                        content={t('inventory-financing-business-card1.description')} 
                        backgroundColor="linear-gradient(138.62deg, #E5DBEF 0.09%, #FFFFFF 69.08%)"
                        image="/images/inventory-card-img1.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card2.title')}  
                        content={t('inventory-financing-business-card2.description')}  
                        backgroundColor="linear-gradient(138.62deg, rgba(252, 196, 157, 0.62) 0.09%, #FFFFFF 69.08%)"
                        image="/images/inventory-card-img2.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card3.title')}  
                        content={t('inventory-financing-business-card3.description')} 
                        backgroundColor="linear-gradient(138.76deg, #D0D9F0 1.91%, #FFFFFF 79.24%)"
                        image="/images/inventory-card-img3.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card4.title')}  
                        content={t('inventory-financing-business-card4.description')}  
                        backgroundColor="linear-gradient(140.06deg, #F4E7D4 1.2%, #FFFFFF 78.92%)"
                        image="/images/inventory-card-img4.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card5.title')} 
                        content={t('inventory-financing-business-card5.description')} 
                        backgroundColor="linear-gradient(139.04deg, #CDE3ED 2.39%, #FFFFFF 67%)"
                        image="/images/inventory-card-img5.png"
                    />
                    <CommercialVehicleCard 
                        title={t('inventory-financing-business-card6.title')} 
                        content={t('inventory-financing-business-card6.description')}  
                        backgroundColor="linear-gradient(138.62deg, #F2CFD7 0.09%, #FFFFFF 76.08%)"
                        image="/images/quick-approval-img.png"
                    />
                    </motion.div>
                </motion.div>
            
        </section>

        </>
                
                
      
    )
}

export default InventoryFinancingBusinessSection;